import { getData } from '@project/services/utils';
import networkService from '../network-service/network.service';
import charityOutreachUrls from './charity-outreach.urls';

const getCharityOutreach = async (id: string) => {
  const url = charityOutreachUrls.getCharityOutreachUrl(id);

  return networkService.get(url).then(getData);
};

const getCharity = async (id: string) => {
  const url = charityOutreachUrls.getCharityUrl(id);

  return networkService.get(url).then(getData);
};

const getAllCharityOutreaches = async () => {
  const url = charityOutreachUrls.getAllCharityOutreachesUrl();

  return networkService.get(url).then(getData);
};

export default {
  getCharityOutreach,
  getCharity,
  getAllCharityOutreaches,
};
